"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
exports.getCustomColor = function (originColor, newColor) { return (newColor ? newColor : originColor); };
var createCustomThemeByColors = function (defaultTheme, _a) {
    var primary = _a.primary, secondary = _a.secondary;
    return core_1.createMuiTheme(__assign(__assign({}, defaultTheme), { palette: {
            primary: {
                main: exports.getCustomColor(defaultTheme.palette.primary.main, primary)
            },
            secondary: {
                main: exports.getCustomColor(defaultTheme.palette.secondary.main, secondary)
            }
        } }));
};
exports.default = createCustomThemeByColors;
